export const fetchJsonAds = async (object, num, chash, show_id) => {
    if (!object) {
        return { news: [], billingNoticeUrl: null };
    }
    try {
        const response = await fetch(`https://ssp.24smi.net/rtb/v2/ad?object=${object}&output=json&num=${num}&chash=${chash}&show_id=${show_id}`);
        const data = await response.json();
        return {
            news: data.news,
            billingNoticeUrl: data.settings && data.settings.billingNoticeUrl
        };
    } catch (error) {
        console.error('Error fetching the data:', error);
        return {
            news: [],
            billingNoticeUrl: null
        };
    }
}
